import React, { createContext, useMemo, useState } from 'react';

const BASE_TITLE = 'Kira Talent';

const HelmetContext = createContext<[string, (...titles: string[]) => void]>([
  BASE_TITLE,
  () => undefined,
]);

const HelmetProvider: React.FC<Partial<{ children: React.ReactNode }>> = ({
  children,
}) => {
  const [title, setTitle] = useState(BASE_TITLE);

  const updateTitle = useMemo(
    () =>
      (...titles: string[]) => {
        if (titles[0].length > 0) {
          setTitle([BASE_TITLE, ...titles].reverse().join(' | '));
        }
      },
    []
  );

  const helmetValues = useMemo<
    [title: string, updateTitle: (...titles: string[]) => void]
  >(() => [title, updateTitle], [title, updateTitle]);

  return (
    <HelmetContext.Provider value={helmetValues}>
      {children}
    </HelmetContext.Provider>
  );
};

export default HelmetProvider;
export { HelmetContext };
